import { IconWrapper } from '../runtime';
export default IconWrapper('rotate-right', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75001 13.9998V9.74976C1.75001 6.43605 4.4363 3.74976 7.75001 3.74976C7.75001 3.74976 7.75001 3.74976 7.75001 3.74976C7.75001 3.74976 11.7882 3.74976 14.3757 3.74976M12.5 1.74976L14.2879 3.53762L14.5 3.74976L14.2879 3.96189L12.5 5.74976M10.75 14.2498H8.25001C7.42158 14.2498 6.75001 13.5782 6.75001 12.7498V10.2498C6.75001 9.42133 7.42158 8.74976 8.25001 8.74976H10.75C11.5784 8.74976 12.25 9.42133 12.25 10.2498V12.7498C12.25 13.5782 11.5784 14.2498 10.75 14.2498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});